import React from 'react';
import { Wrapper } from './styles';

const Paper: React.FC = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default Paper;
